__turbopack_context__.v({
  "column": "NavPanelContent-module__IX0oeW__column",
  "columnHeader": "NavPanelContent-module__IX0oeW__columnHeader",
  "columnHeaderInline": "NavPanelContent-module__IX0oeW__columnHeaderInline" + " " + "NavPanelContent-module__IX0oeW__columnHeader",
  "columns": "NavPanelContent-module__IX0oeW__columns",
  "introLine": "NavPanelContent-module__IX0oeW__introLine",
  "mainLink": "NavPanelContent-module__IX0oeW__mainLink",
  "navLink": "NavPanelContent-module__IX0oeW__navLink",
  "subColumns": "NavPanelContent-module__IX0oeW__subColumns",
  "subLinks": "NavPanelContent-module__IX0oeW__subLinks",
});
